import React from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import File from "@peracto/peracto-editor-ui/dist/File";

const TripleHeroForm = ({
    onChange,
    state: {
        hero1Url = "",
        hero1Heading = "Hero 1",
        hero1ButtonLink = "",
        hero2Url = "",
        hero2Heading = "Hero 2",
        hero2ButtonLink = "",
        hero3Url = "",
        hero3Heading = "Hero 3",
        hero3ButtonLink = "",
    },
}) => {
    return (
        <>
            <File
                label={`Hero 1 Image URL`}
                value={hero1Url}
                onChange={(value) => onChange({ hero1Url: value })}
                isInline={false}
            />

            <TextInput
                label="Hero 1 Heading"
                value={hero1Heading}
                onChange={(e) => onChange({ hero1Heading: e.target.value })}
            />

            <TextInput
                label="Hero 1 Link"
                value={hero1ButtonLink}
                onChange={(e) => onChange({ hero1ButtonLink: e.target.value })}
            />

            <div className="w-full h-[1px] bg-brand-grey my-[15px]"></div>

            <File
                label={`Hero 2 Image URL`}
                value={hero2Url}
                onChange={(value) => onChange({ hero2Url: value })}
                isInline={false}
            />

            <TextInput
                label="Hero 2 Heading"
                value={hero2Heading}
                onChange={(e) => onChange({ hero2Heading: e.target.value })}
            />

            <TextInput
                label="Hero 2 Link"
                value={hero2ButtonLink}
                onChange={(e) => onChange({ hero2ButtonLink: e.target.value })}
            />

            <div className="w-full h-[1px] bg-brand-grey my-[15px]"></div>

            <File
                label={`Hero 3 Image URL`}
                value={hero3Url}
                onChange={(value) => onChange({ hero3Url: value })}
                isInline={false}
            />

            <TextInput
                label="Hero 3 Heading"
                value={hero3Heading}
                onChange={(e) => onChange({ hero3Heading: e.target.value })}
            />

            <TextInput
                label="Hero 3 Link"
                value={hero3ButtonLink}
                onChange={(e) => onChange({ hero3ButtonLink: e.target.value })}
            />
        </>
    );
};

export default TripleHeroForm;
